import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import styled from "styled-components";

const TableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "Nunito";
`;

const TableHeader = styled.thead`
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const TableHeaderCell = styled.th`
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  font-weight: 700;
  font-size: 14px;
  color: #495057;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8f9fa;
  }

  &:hover {
    background-color: #e9ecef;
  }
`;

const TableCell = styled.td`
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
  color: #495057;
  vertical-align: top;
`;

const ErrorsTableModal = ({ isOpen, toggle, errors = [], title = "Errores de Calendarización" }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" style={{ fontFamily: "Nunito" }} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <strong>Se encontraron {errors.length} errores que impiden la calendarización:</strong>
        </div>

        <TableContainer>
          <StyledTable>
            <TableHeader>
              <tr>
                <TableHeaderCell style={{ width: "60px" }}>#</TableHeaderCell>
                <TableHeaderCell>Descripción del Error</TableHeaderCell>
              </tr>
            </TableHeader>
            <TableBody>
              {errors.map((error, index) => (
                <TableRow key={`${error}`}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{error}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>

        <div className="mt-3 text-muted">
          <small>Por favor, corrija estos errores antes de intentar calendarizar nuevamente.</small>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ErrorsTableModal;
